import {FileText} from 'lucide-react'
import {Navigate} from 'react-router-dom'
import TopBarProgress from 'react-topbar-progress-indicator'
import {PageTitle} from '../../../../../_metronic/layout/core'
import {GetPermissions} from '../../../../modules/auth/core/Auth'
import type {BriefingTopic} from '../data/topics'
import {getTopicForm} from '../data/topicForms'
import TopicRequestForm from '../components/TopicRequestForm'

type Props = {topic: BriefingTopic}

export default function BriefingTopicPage({topic}: Props) {
  const permissions = GetPermissions()
  if (!permissions?.length) return <TopBarProgress />
  if (!permissions.some((permission) => permission.name === topic.permission)) {
    return <Navigate to='/error/404' replace />
  }
  const definition = getTopicForm(topic.id)
  return (
    <div className='min-w-0 bg-gray-50 pb-6'>
      <PageTitle>{topic.title}</PageTitle>
      <div style={{maxWidth: 1120, width: '100%', margin: '0 auto'}}>
        <div className='mb-6'>
          <p className='mb-3 text-gray-500' style={{fontSize: 12}}>
            Briefing Promoções / Tópicos
          </p>
          <div className='flex items-start gap-3'>
            <div
              className='flex shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600'
              style={{width: 44, height: 44}}
            >
              <img src={topic.icon} alt='' width={28} height={28} aria-hidden='true' />
            </div>
            <div className='min-w-0'>
              <h1
                className='mb-1 break-words font-semibold text-gray-900'
                style={{fontSize: 'clamp(20px, 2.2vw, 26px)', lineHeight: 1.35}}
              >
                {topic.title}
              </h1>
              <p className='mb-0 text-gray-500' style={{fontSize: 13, lineHeight: 1.6}}>
                Preencha e consulte as solicitações deste tópico.
              </p>
            </div>
          </div>
        </div>
        {definition ? (
          <TopicRequestForm key={topic.id} topic={topic} definition={definition} />
        ) : (
          <div className='rounded-lg border border-gray-200 bg-white p-8 text-center'>
            <FileText className='mx-auto mb-4 h-10 w-10 text-blue-600' aria-hidden='true' />
            <h2 className='mb-2 text-lg font-semibold text-gray-900'>Tela em preparação</h2>
            <p className='text-sm text-gray-500'>
              Os campos e as ações deste tópico serão definidos em uma próxima etapa.
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
